import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { Toaster } from "./components/ui/Toaster.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { ToastProvider } from "./hooks/use-toast.tsx";
import ReloadPrompt from "./components/ReloadPrompt.tsx";
import InstallPrompt from "./components/InstallPrompt.tsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <ToastProvider>
      <App />
      <Toaster />
      <ReloadPrompt />
      <InstallPrompt />
    </ToastProvider>
  </AuthProvider>
);
